import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["submitButton", "enableWebsiteInput", "enableAppointmentInput"]

  connect(){
    this.readMode = JSON.parse(this.data.get("read-mode"))
    this.syncDisableSubmit()
  }

  handleEnableWebsiteChange(event) {
    if (this.readMode) {
      return
    }
    const memberId = event.currentTarget.getAttribute("data-member-id")
    const input = this.element.querySelector(`.professional-specialty-input[data-member-id="${memberId}"]`)
    if (!input) return false;

    if(event.currentTarget.checked){
      input.removeAttribute("disabled")
      input.setAttribute("required", "required")
      this.removeDisableSubmit()
    } else {
      input.removeAttribute("required")
      input.setAttribute("disabled", "disabled")
      this.syncDisableSubmit()
    }
  }

  addDisableSubmit() {
    this.submitButtonTargets.map(button => button.setAttribute("disabled", "disabled"))
  }

  removeDisableSubmit() {
    this.submitButtonTargets.map(button => button.removeAttribute("disabled"))
  }

  syncDisableSubmit() {
    if (this.readMode) {
      this.addDisableSubmit();
      return
    }
    if (!this.enableAppointmentInputTarget.checked) {
      return this.removeDisableSubmit();
    }
    if (this.enableWebsiteInputTargets.filter((input) => input.checked).length > 0) {
      return this.removeDisableSubmit();
    }
    this.addDisableSubmit();
  }

  handleEnableAppointmentChange() {
    this.syncDisableSubmit()
  }
}
